var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRevert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.796,
    height: 20,
    viewBox: "0 0 23.796 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Arrow_Left_1_",
    d: "M23.695,22.368c.037-.25.825-6.254-2.706-10.385-2.169-2.539-5.516-3.928-9.838-4.066l-.023-4.174a.744.744,0,0,0-1.214-.576L.273,11.08a.744.744,0,0,0,0,1.151l9.643,7.988a.743.743,0,0,0,1.215-.574l.023-4.267c10.417-.007,11.158,6.667,11.183,6.943A.679.679,0,0,0,22.98,23H23A.7.7,0,0,0,23.695,22.368ZM9.86,14.1a.744.744,0,0,0-.219.526v3.449L1.917,11.66,9.642,5.308V8.649a.743.743,0,0,0,.744.744c4.231,0,7.463,1.225,9.47,3.551a10.961,10.961,0,0,1,2.44,5.671c-1.624-2.219-4.467-4.731-11.909-4.736h0A.742.742,0,0,0,9.86,14.1Z",
    transform: "translate(0.001 -3)",
    fill: "#050241"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevert);
export default __webpack_public_path__ + "static/media/revert.74d214422cba601d0914891eccdbe4ef.svg";
export { ForwardRef as ReactComponent };